"use strict";
/**
 * Created on 02 26 2020
 */

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");
/**
 * General representation of key encapsulating id of {@link Release release} and id of {@link Product product} within a release.
 * <br/>
 * We can group product id with release together (without release item id), because for regular releases, product id is unique per release.
 * <br/>
 * You can use this tuple as a key of immutable map or as a value of immutable set.
 * @author JMe
 */


var ProductReleaseKey =
/*#__PURE__*/
function () {
  /**
   * Ctor.
   *
   * @param productId identification of a product
   * @param releaseId identification of a release
   */
  function ProductReleaseKey(productId, releaseId) {
    _classCallCheck(this, ProductReleaseKey);

    this.productId = productId;
    this.releaseId = releaseId;
  }

  _createClass(ProductReleaseKey, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof ProductReleaseKey) {
        var otherKey = other;
        return this.releaseId === otherKey.releaseId && this.productId === otherKey.productId;
      } else {
        return false;
      }
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode("".concat(this.productId, "_").concat(this.releaseId));
    }
  }]);

  return ProductReleaseKey;
}();

exports.ProductReleaseKey = ProductReleaseKey;
/**
 * Extension of {@link ProductReleaseKey} about item id reference.
 * @author JMe
 */

var ProductReleaseItemKey =
/*#__PURE__*/
function (_ProductReleaseKey) {
  _inherits(ProductReleaseItemKey, _ProductReleaseKey);

  /**
   * Ctor.
   *
   * @param productId identification of a product
   * @param releaseId identification of a release
   */
  function ProductReleaseItemKey(productId, releaseId, itemId) {
    var _this;

    _classCallCheck(this, ProductReleaseItemKey);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductReleaseItemKey).call(this, productId, releaseId));
    _this.productId = productId;
    _this.releaseId = releaseId;
    _this.itemId = itemId;
    return _this;
  }

  _createClass(ProductReleaseItemKey, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof ProductReleaseItemKey) {
        var otherKey = other;
        return this.releaseId === otherKey.releaseId && this.productId === otherKey.productId && this.itemId === otherKey.itemId;
      } else {
        return false;
      }
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode("".concat(this.productId, "_").concat(this.releaseId, "_").concat(this.itemId));
    }
  }]);

  return ProductReleaseItemKey;
}(ProductReleaseKey);

exports.ProductReleaseItemKey = ProductReleaseItemKey;